export const PelletServicePagesList = [
  {
    name: `Pelletlieferung`,
    title: `Wie läuft eine Pelletlieferung ab? Ablauf, Vorbereitung und Tipps`,
    link: { path: `/pelletspreise/services/pelletlieferung` },
    externalLink: false,
  },
  {
    name: `Pellets bestellen`,
    title: `Wie viele Pellets bestellen? Bedarfsrechner und Entscheidungshilfe`,
    link: { path: `/pelletspreise/services/pellets-bestellen` },
    externalLink: false,
  },
  {
    name: `Mindestbestellmenge`,
    title: `Mindestbestellmenge bei Pellets: Was wirklich gilt`,
    link: { path: `/pelletspreise/services/mindestbestellmenge` },
    externalLink: false,
  },
  {
    name: `Zahlarten`,
    title: `Welche Zahlarten sind beim Pellets-Preisvergleich möglich?`,
    link: { path: `/pelletspreise/services/zahlarten` },
    externalLink: false,
  },
];
